import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { ApiService } from 'services';
import NoInternetPage from 'components/Errors/NoInternetPage';
import LocalisedMessage from 'components/Common/LocalisedMessage';

import { updateConnectionStatus } from 'actions/app';

class ConnectionStatus extends Component {
  static propTypes = {
    // basicCheckUrl: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    onConnectionChanged: PropTypes.func,
    children: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node
    ]).isRequired,
    retries: PropTypes.number,
    showFullScreen: PropTypes.bool,
    connectionInfo: PropTypes.shape({
      rtt: PropTypes.number,
      downlink: PropTypes.number
    }),
    isOnline: PropTypes.bool,
    fullScreenOnly: PropTypes.bool,
    shortDictionaryLoaded: PropTypes.bool
  };

  static defaultProps = {
    // basicCheckUrl: 'https://www.taina.tech/generate_204',
    onConnectionChanged: (event) => {},
    retries: 0,
    showFullScreen: false,
    connectionInfo: null,
    isOnline: true,
    fullScreenOnly: false,
    shortDictionaryLoaded: false
  };

  static CONNECTION_STATE_CHANGED = 'connection-state';

  static eventListenersLock = 0;

  static eventListenersSet = 0;

  static createConnectionStateEvent(isOnline) {
    const event = document.createEvent('CustomEvent');
    event.initCustomEvent(this.CONNECTION_STATE_CHANGED, true, true, { isOnline, state: isOnline ? 'Online' : 'Offline', date: new Date() });
    return event;
  }

  static handleOnlineOfflineEvent(event) {
    if (event && event.type && (event.type === 'online' || event.type === 'offline')) {
      const newState = event.type === 'online';
      window.dispatchEvent(ConnectionStatus.createConnectionStateEvent(newState));
    }
  }

  componentDidMount() {
    this.setEventListeners();
  }

  componentWillUnmount() {
    this.removeEventListeners();
  }

  handleConnectionStateChanged(event) {
    const { dispatch, onConnectionChanged, retries } = this.props;
    if (ApiService.globalRetryCount > 0 && event.detail.isOnline) {
      ApiService.globalRetryCount = 0;
      ApiService.processQueuedPromises(true);
    }

    dispatch(updateConnectionStatus(event.detail.isOnline, retries));
    if (onConnectionChanged) {
      onConnectionChanged(event);
    }
  }

  handleConnectionChanged(event) {
    const { isOnline } = this.props;
    const networkInfo = event.target;
    if (!isOnline && (networkInfo.rtt > 0 && networkInfo.downlink > 0)) {
      window.dispatchEvent(ConnectionStatus.createConnectionStateEvent(true));
    } else if (isOnline && (networkInfo.rtt === 0 || networkInfo.downlink === 0)) {
      window.dispatchEvent(ConnectionStatus.createConnectionStateEvent(false));
    }
  }

  /* eslint-disable no-dupe-class-members */
  handleConnectionChanged = this.handleConnectionChanged.bind(this);

  handleConnectionStateChanged = this.handleConnectionStateChanged.bind(this);
  /* eslint-enable no-dupe-class-members */

  setEventListeners() {
    const connection = null;

    const crypto = window.crypto || window.msCrypto;
    const randomArray = new Uint32Array(1);
    crypto.getRandomValues(randomArray);

    const lockKey = randomArray[0] * (2 ** 32);
    // console.log(`Connection: ${ JSON.stringify(connection) }`);
    if (ConnectionStatus.eventListenersLock === 0) {
      ConnectionStatus.eventListenersLock = lockKey;
    }

    if (ConnectionStatus.eventListenersLock !== lockKey) {
      return;
    }

    if (ConnectionStatus.eventListenersSet === 0) {
      if (connection && connection.downlink >= 0 && connection.rtt >= 0) {
        connection.addEventListener('change', this.handleConnectionChanged);
      } else {
        window.addEventListener('online', ConnectionStatus.handleOnlineOfflineEvent);
        window.addEventListener('offline', ConnectionStatus.handleOnlineOfflineEvent);
      }

      window.addEventListener(ConnectionStatus.CONNECTION_STATE_CHANGED, this.handleConnectionStateChanged);
    }

    ConnectionStatus.eventListenersSet += 1;
    ConnectionStatus.eventListenersLock = 0;
  }

  getCssClass() {
    const { isOnline, showFullScreen } = this.props;
    if (isOnline) {
      return 'connected';
    }

    if (showFullScreen) {
      return 'full-screen';
    }

    return 'disconnected';
  }

  removeEventListeners() {
    if (ConnectionStatus.eventListenersSet === 1) {
      if (window.navigator) {
        const connection = null;
        if (connection) {
          connection.removeEventListener('change', this.handleConnectionChanged);
        }
      }
      window.removeEventListener('online', ConnectionStatus.handleOnlineOfflineEvent);
      window.removeEventListener('offline', ConnectionStatus.handleOnlineOfflineEvent);
      window.removeEventListener(ConnectionStatus.CONNECTION_STATE_CHANGED, this.handleConnectionStateChanged);
    }

    ConnectionStatus.eventListenersSet -= 1;
  }

  render() {
    const { children, showFullScreen, fullScreenOnly, isOnline, shortDictionaryLoaded } = this.props;

    return <React.Fragment>
      { !isOnline && shortDictionaryLoaded && showFullScreen && <div className="connection-status overlay" /> }
      { (!fullScreenOnly || !isOnline) && shortDictionaryLoaded && <div className={ `connection-status ${ this.getCssClass() }` }>
          { !isOnline && !showFullScreen && children != null && children }
          { !isOnline && showFullScreen && <NoInternetPage />}
          { isOnline && <LocalisedMessage id="connectionStatus.banner.online" /> }
        </div> }
    </React.Fragment>;
  }
}

function mapStateToProps(state) {
  const {
    app: {
      isOnline,
      connectionInfo,
      shortDictionaryLoaded
    }
  } = state;

  return {
    isOnline,
    retries: ApiService.globalRetryCount,
    connectionInfo: connectionInfo || null,
    showFullScreen: ApiService.globalRetryCount > 1,
    shortDictionaryLoaded
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectionStatus);
